// src/controllers/egresoDropEscoltaController.js

import { 
  getEgresoDropEscoltas, 
  addEscoltasToDrop, 
  deleteAllEscoltasFromDrop 
} from '../models/egresoDropEscoltaModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase.js';
import { toasts } from "svelte-toasts";

// Retry utility function
async function retryRequest(fn, maxRetries = 3, delay = 1000) {
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await fn();
    } catch (error) {
      console.warn(`Attempt ${i + 1} failed:`, error.message);
      if (i === maxRetries - 1) throw error;
      await new Promise(resolve => setTimeout(resolve, delay * (i + 1)));
    }
  }
}

// Cargar las escoltas de un drop
export async function fetchEgresoDropEscoltas(egresoDropId) {
  try {
    const response = await retryRequest(() => getEgresoDropEscoltas(egresoDropId, 1, 100));
    return response.items || [];
  } catch (error) {
    console.error("Error fetching egresoDropEscoltas:", error);
    // Don't show error modal for individual requests to avoid spam
    return [];
  }
}

// Guardar escoltas para un drop
export async function saveDropEscoltas(egresoDropId, escoltaIds) {
  console.log("saveDropEscoltas called with:", { egresoDropId, escoltaIds });
  try {
    // Step 1: Delete any existing escoltas for this drop
    console.log("Step 1: Deleting existing escoltas for drop:", egresoDropId);
    await deleteAllEscoltasFromDrop(egresoDropId);
    console.log("Step 1: Existing escoltas deleted successfully");

    // Step 2: Add new escoltas from the payload
    if (escoltaIds && escoltaIds.length > 0) {
      console.log("Step 2: Adding new escoltas:", escoltaIds);
      await addEscoltasToDrop(egresoDropId, escoltaIds);
      console.log("Step 2: New escoltas added successfully");
    } else {
      console.log("Step 2: No escoltas to add (empty array)");
    }

    toasts.add({
      title: 'Éxito',
      description: 'Escoltas del drop actualizadas exitosamente',
      duration: 3000,
      placement: 'bottom-right',
      type: 'success',
      theme: 'dark',
      showProgress: true
    });
    console.log("saveDropEscoltas completed successfully");
  } catch (error) {
    console.error("Error saving drop escoltas:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar las escoltas del drop',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

// Suscripción en tiempo real a cambios en la colección 'egresoDropEscolta'
export function subscribeToEgresoDropEscoltas(handleSearch) {
  pb.collection('egresoDropEscolta').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1); // Actualiza la lista con la primera página
  });
}

// Desuscripción de los eventos en tiempo real
export function unsubscribeFromEgresoDropEscoltas() {
  pb.collection('egresoDropEscolta').unsubscribe('*');
} 